import { Answer } from 'models/AnswerModel';
import { Question } from 'models/QuestionModel';
import { FileUploadOption } from 'data/FileUploadOption';

export const findIndexOfAnswer = (question: Question, value: string): number => {
  return question.Answers?.findIndex((answer) => answer.Condition === value) ?? -1;
};

export const getSelectedAnswer = (question: Question, answers: Record<string, string>) => {
  const selectedValue = answers[question.Id];
  if (selectedValue === undefined || !question.Answers) return null;

  if (/^\d+$/.test(selectedValue)) {
    const index = parseInt(selectedValue, 10);
    return index < question.Answers.length ? question.Answers[index] : null;
  }

  return question.Answers.find((answer) => answer.Condition === selectedValue) || null;
};

export const shouldShowFileUpload = (selectedAnswer: Answer | null): boolean =>
  selectedAnswer?.FileUpload === FileUploadOption.Required || selectedAnswer?.FileUpload === FileUploadOption.Optional;

export const isFileUploadRequired = (selectedAnswer: Answer | null): boolean => selectedAnswer?.FileUpload === FileUploadOption.Required;

const extractTokens = (text: string): string[] => {
  if (!text) return [];

  const decodedText = text.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&');
  const tokenRegex = /\{\{([^}]+)\}\}/g;
  const tokens: string[] = [];
  let match;

  while ((match = tokenRegex.exec(decodedText)) !== null) {
    const token = match[1].replace(/<[^>]+>/g, '').trim();
    tokens.push(token);
  }

  return tokens;
};

export const tokensForQuestion = (question: Question, answers: Record<string, string>): string[] => {
  const selectedAnswer = getSelectedAnswer(question, answers);
  if (!selectedAnswer && (question.Answers?.length ?? 0) > 1) return [];

  const relevantAnswer = selectedAnswer || question.Answers?.[0];
  if (!relevantAnswer) return [];

  return extractTokens(relevantAnswer.Answer);
};
